// extracted by mini-css-extract-plugin
export default {"labels":"lsf-labels","labels_hidden":"lsf-labels_hidden","labels_inline":"lsf-labels_inline"};
    if(module.hot) {
      // 1732531520751
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  